<template>
    <m v-if="mobileMode"></m>
    <pc v-else></pc>
</template>

<script>
/* eslint-disable */
import pc from './PC.vue'
import m from './M.vue'
export default {
  name: "Root",
  components: {pc, m },
  data () {
    return{
      mobileMode: false
    }
  },
  created: function () {
    this.mobileMode = this.$utils.isMobile()
  }
}
</script>

<style scoped>

</style>